/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum org_coursera_userverification_idverification_IdVerificationApprovalSource {
  ADMIN = "ADMIN",
  JUMIO = "JUMIO",
  NAME_ATTEST = "NAME_ATTEST",
  NONE = "NONE",
  SIGTRACK = "SIGTRACK",
  SSO_SIGNIN = "SSO_SIGNIN",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
